import * as Icons from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DASHBOARD_ROUTES } from "utils/constants";

import wallet from "../../../assets/icons/wallet.svg";
import {
  CategoryIcon,
  RemainingQuestions,
  RewardCard,
  Status,
  SubContainer,
  TitleContainer,
  TitleText,
} from "./style.components";

const Rewards = ({ category, onClick }: any) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (category?.questionsAnswered === category?.totalQuestions) return;
    navigate(`/dashboard/${DASHBOARD_ROUTES.SURVEY_PROFILE}/${category.name}`, {
      state: {
        categoryId: category?.id,
        category: category?.name,
      },
    });
  };

  const IconComponent = (Icons as any)[category?.icon] || null;

  return (
    <RewardCard onClick={handleClick}>
      <SubContainer>
        <TitleContainer>
          <CategoryIcon>
            {IconComponent ? (
              <IconComponent sx={{ fontSize: 24 }} />
            ) : (
              <img src={wallet} alt="category icon" width="24" height="24" />
            )}
          </CategoryIcon>
          <TitleText>{category?.name}</TitleText>
        </TitleContainer>
        <Status status={category?.status === "New"}>{category?.status}</Status>
      </SubContainer>
      <SubContainer>
        <RemainingQuestions status={category?.status}>
          {category?.questionText}
        </RemainingQuestions>
      </SubContainer>
    </RewardCard>
  );
};

export default Rewards;
